export enum ChampionshipStatus {
  OPEN = 'open',
  CLOSE = 'close',
}
